import { createRouter, createWebHistory } from 'vue-router'
import AppsPage from '../views/AppsPage.vue'
import AppDetails from '../views/AppDetails.vue'

const routes = [
	{ path: '/', name: 'Apps', component: AppsPage },
	{ path: '/app/:id', name: 'AppDetails', component: AppDetails }
]

const router = createRouter({
	history: createWebHistory(),
	routes
})

export default router